import { useEffect, useState } from "react";
import { publicCalculators } from "@/data/calculators";

const KEY = "ch_recent";
const MAX = 6;
const publicCalculatorSlugs = new Set(publicCalculators.map((calculator) => calculator.slug));

export interface RecentItem {
  slug: string;
  title: string;
  categoryName: string;
  categorySlug: string;
}

function readStorage(): RecentItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    const parsed: unknown = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter(
        (item): item is RecentItem =>
          typeof item === "object" &&
          item !== null &&
          "slug" in item &&
          typeof item.slug === "string" &&
          publicCalculatorSlugs.has(item.slug),
      )
      .slice(0, MAX);
  } catch {
    return [];
  }
}

export function trackView(item: RecentItem) {
  if (!publicCalculatorSlugs.has(item.slug)) return;
  try {
    const prev = readStorage();
    const next = [item, ...prev.filter((r) => r.slug !== item.slug)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch { /* ignore */ }
}

export function useRecentlyViewed() {
  const [recent, setRecent] = useState<RecentItem[]>([]);
  useEffect(() => {
    setRecent(readStorage());
  }, []);
  return recent;
}
